module.exports = { "default": require("core-js/library/fn/object/prevent-extensions"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/babel-runtime/core-js/object/prevent-extensions.js
// module id = 1138
// module chunks = 168707334958949